import {
  dataMap
} from '@/cllib/sys_lib'

import {
  dateOperating
} from '@/cllib/tools'

import {
  gasPiOrderGetData,
  piGasTankStatusGetStatus,
  piGasTankStatusGetDistribution,
  routerOrderGetDataByInfo
} from '@/api/api'

import {
  getDataPeriod,
  getCanPeratePeriod,
  getHourStatus,
  generateChartOption,
  checkGasTankData
} from '@/cllib/pi'

import {
  updateEchartLineData
} from '@/cllib/echart_option'

const initPiGasTank = () => {
  return {
    id: null,
    validCapacity: 0,
    stopPumpCapacity: 0,
    preSales: 0,
    gasName: null,
    oilName: null,
    tankMark: null,
    startInventory: 0,
    collectTime: null,
    hourSalesRate: [],
    // 在途小时数
    wayHour: 0,
    pass: false
  }
}

const initPiDataPeriod = () => {
  return {
    dataStartTime: null,
    dataEndTime: null,
    pass: false
  }
}

const initPiCanPeratePeriod = () => {
  return {
    perateStartTime: null,
    perateEndTime: null,
    pass: false
  }
}

const typeTextMap = {
  distributionOrderWay: '在途',
  distributionOrderPlan: '计划',
  distributionOrderEnd: '入库',
  routerOrder: '预计划',
  piOrder: '订单'
}

const hourSalesRate98 = [1.85, 0.97, 0.39, 0.08, 0.00, 0.57, 0.32, 0.99, 3.28, 6.55, 9.58, 4.18, 2.53, 5.24, 5.86, 13.03, 6.86, 5.87, 5.53, 6.73, 8.76, 5.97, 2.68, 2.15]
const hourSalesRate95 = [1.18, 0.51, 0.43, 0.26, 0.17, 0.32, 0.69, 4.36, 6.93, 7.76, 6.68, 6.18, 5.95, 6.42, 6.27, 6.19, 6.13, 5.47, 6.46, 5.76, 5.33, 4.59, 3.73, 2.21]
const hourSalesRate92 = [1.68, 1.05, 0.76, 0.92, 0.93, 1.03, 1.61, 4.73, 6.23, 7.45, 7.08, 6.26, 5.15, 5.27, 5.28, 5.17, 5.93, 5.23, 6.02, 5.93, 5.46, 5.06, 3.59, 2.17]
const hourSalesRate0 = [2.55, 2.28, 1.28, 0.59, 1.11, 2.87, 2.12, 1.53, 3.43, 5.74, 7.20, 5.72, 3.48, 10.84, 8.81, 5.87, 3.61, 3.84, 3.53, 9.18, 4.67, 3.29, 2.26, 4.21]

let piDateStr = dataMap().tomorrowStr
let piDate = dateOperating.formatDate({date: piDateStr + ' 00:00'})

const state = {
  // 图表类型 pi route
  piChartType: '',
  piChartShowXL: true,
  // 配送日期
  piDate: piDate,
  piDateStr: piDateStr,
  // gas_pi_order
  piGasPiOrder: [],
  // gas_router_order
  piGasRouterOrder: [],
  // gas_distribution_order
  piGasDistributionOrder: [],
  // 操作的罐的id
  piGasTankId: null,
  // 油罐数据
  piGasTank: initPiGasTank(),
  // 数据时间段  图表时间范围
  piDataPeriod: initPiDataPeriod(),
  // 可操作时间区间
  piCanPeratePeriod: initPiCanPeratePeriod(),
  // 每小时状态
  piHourStatus: [],
  // 库存走势图option
  piStockChartOption: null,
  // 整理后的入库单
  piInOrder: [],
  piErrorInfo: {}
}

const getters = {
  piChartType: state => state.piChartType,
  piChartShowXL: state => state.piChartShowXL,
  piGasTankId: state => state.piGasTankId,
  piStockChartOption: state => state.piStockChartOption,
  piDateStr: state => state.piDateStr,
  piDate: state => state.piDate,
  piGasTank: state => state.piGasTank,
  piDataPeriod: state => state.piDataPeriod,
  piInOrder: state => state.piInOrder,
  piHourStatus: state => state.piHourStatus,
  piCanPeratePeriod: state => state.piCanPeratePeriod,
  piGasPiOrder: state => state.piGasPiOrder,
  piGasRouterOrder: state => state.piGasRouterOrder,
  piGasDistributionOrder: state => state.piGasDistributionOrder,
  piErrorInfo: state => state.piErrorInfo,
  caninitPiHourStatus: (state) => {
    return state.piGasTank.pass && state.piDataPeriod.pass
  }
}

const actions = {
  loadPiRouterOrder ({ dispatch, getters }) {
    if (getters.piDateStr && getters.piGasTankId && getters.piChartType === 'route') {
      let parm = {
        gasTankId: getters.piGasTankId,
        sendTime: getters.piDateStr
      }
      routerOrderGetDataByInfo(parm).then((data) => {
        data.forEach((item) => {
          item.arriveTime = item.expectArriveTime
        })
        dispatch('setPiRouterOrder', data)
      })
    } else {
      dispatch('setPiRouterOrder', [])
    }
  },
  setPiRouterOrder ({ dispatch, commit }, data) {
    commit('setPiRouterOrder', data)
    dispatch('updatePiInOrderByType', {type: 'routerOrder', data})
  },
  setPiChartShowXL ({ dispatch, commit }, data) {
    commit('setPiChartShowXL', data)
    dispatch('updatePiStockChartOption')
  },
  loadPiGasPiOrder ({ dispatch, getters }) {
    if (getters.piChooseGasOrder && getters.piChooseGasOrder.id && getters.piChartType === 'pi') {
      gasPiOrderGetData(getters.piChooseGasOrder.id).then((data) => {
        dispatch('setPiGasPiOrder', data)
      })
    } else {
      dispatch('setPiGasPiOrder', [])
    }
  },
  setPiGasPiOrder ({ dispatch, commit }, data) {
    commit('setPiGasPiOrder', data)
    dispatch('updatePiInOrderByType', {type: 'piOrder', data})
  },
  loadPiDistributionOrder ({ dispatch, getters }) {
    let parm = {
      gasTankId: getters.piGasTankId,
      queryDate: dateOperating.computeDay({days: -1, date: getters.piDateStr, format: 'yy-mm-dd'})
    }
    piGasTankStatusGetDistribution(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          arriveTime: new Date(item.inTime || item.expectArriveTime),
          volume: item.inVolume || item.loadVolume || item.planVolume,
          status: item.status,
          licenseNo: item.licenseNo
        })
      })
      dispatch('setPiDistributionOrder', newData)
    })
  },
  loadPiGasTankData ({ dispatch, getters }) {
    let parm = {
      id: getters.piGasTankId,
      collectTime: dateOperating.computeDay({days: -1, date: getters.piDateStr, format: 'yy-mm-dd'}),
      sendTime: getters.piDateStr
    }
    piGasTankStatusGetStatus(parm).then((data) => {
      if (data.length > 0) {
        data = data[0]
        let hourSalesRate = hourSalesRate0
        if (data.oilName.includes('98')) {
          hourSalesRate = hourSalesRate98
        } else if (data.oilName.includes('95')) {
          hourSalesRate = hourSalesRate95
        } else if (data.oilName.includes('92')) {
          hourSalesRate = hourSalesRate92
        }
        let wayHour = data.onWayHour || parseInt(data.distance / 50) + 1
        let newData = {
          id: data.id,
          validCapacity: data.validCapacity,
          stopPumpCapacity: data.stopPumpCapacity,
          preSales: data.outVolume === null ? data.dailyOutVolume : data.outVolume,
          startInventory: data.endInventory,
          collectTime: new Date(data.collectTime.length > 10 ? data.collectTime : (data.collectTime + ' 00:00')),
          gasName: data.gasName,
          oilName: data.oilName,
          tankMark: data.tankMark,
          hourSalesRate,
          // 在途小时数
          wayHour
        }
        dispatch('setPiGasTankData', newData)
      } else {
        dispatch('setPiGasTankData', initPiGasTank())
      }
    })
  },
  setPiDistributionOrder ({ dispatch, commit }, data) {
    commit('setPiDistributionOrder', data)
    dispatch('updatePiInOrderByType', {type: 'distributionOrder', data})
  },
  setPiGasTankId ({ commit, dispatch }, {gasTankId, piChartType}) {
    commit('setPiGasTankId', gasTankId)
    commit('setPiChartType', piChartType)
    dispatch('initData')
  },
  initData ({ dispatch }) {
    dispatch('clearPiErrorInfo')
    dispatch('setPiDistributionOrder', [])
    dispatch('setPiGasPiOrder', [])
    dispatch('setPiRouterOrder', [])
    dispatch('setPiGasTankData', initPiGasTank(), true)
    dispatch('piLoadData')
  },
  piLoadData ({ dispatch, getters }) {
    if (getters.piGasTankId) {
      dispatch('loadPiGasTankData')
      dispatch('loadPiRouterOrder')
      dispatch('loadPiGasPiOrder')
      dispatch('loadPiDistributionOrder')
    }
  },
  updatePiInOrderByType ({ commit, dispatch }, data) {
    commit('updatePiInOrderByType', data)
    dispatch('initPiHourStatus')
  },
  setPiInOrder ({ commit, dispatch }, data) {
    commit('setPiInOrder', data)
  },
  setPiGasTankData ({ dispatch, commit, getters }, data, isInit) {
    let checkResult = checkGasTankData(data)
    data.pass = checkResult.pass
    commit('setPiGasTankData', data)
    // 获取可选择送达时间
    dispatch('setPiCanPeratePeriod', getCanPeratePeriod(getters.piDate, data.wayHour || 0))
    if (data.pass) {
      // 获取数据起止时间
      dispatch('setPiDataPeriod', getDataPeriod(data.collectTime, getters.piDate, data.wayHour))
    } else {
      if (data.id) {
        dispatch('showNoticeMsg', {type: 'error', title: '数据异常', message: checkResult.msg})
      }
      dispatch('setPiErrorInfo', {key: 'gasTank', errorText: checkResult.msg})
      dispatch('setPiDataPeriod', initPiDataPeriod())
    }
    dispatch('setPiErrorInfo', {key: 'gasTank', errorText: data.pass ? null : checkResult.msg})
    dispatch('initPiHourStatus')
  },
  initPiHourStatus ({ getters, dispatch }) {
    if (getters.caninitPiHourStatus) {
      dispatch('setPiHourStatus', getHourStatus({
        startInventory: getters.piGasTank.startInventory,
        validCapacity: getters.piGasTank.validCapacity,
        stopPumpCapacity: getters.piGasTank.stopPumpCapacity,
        preSales: getters.piGasTank.preSales,
        hourSalesRate: getters.piGasTank.hourSalesRate,
        dataStartTime: getters.piDataPeriod.dataStartTime,
        dataEndTime: getters.piDataPeriod.dataEndTime,
        order: getters.piInOrder
      }))
    } else {
      dispatch('setPiHourStatus', [])
    }
  },
  updatePiStockChartOption ({ getters, commit }) {
    if (getters.piGasTank.pass && getters.piHourStatus.length > 0) {
      commit('setPiStockChartOption', updateEchartLineData(generateChartOption(getters.piHourStatus, getters.piGasTank.validCapacity, getters.piGasTank.stopPumpCapacity, getters.piCanPeratePeriod, getters.piChartShowXL)))
    } else {
      commit('setPiStockChartOption', null)
    }
  },
  setPiDataPeriod ({ commit, dispatch }, data) {
    data.pass = data.dataStartTime && data.dataEndTime
    dispatch('setPiErrorInfo', {key: 'dataPeriod', errorText: data.pass ? null : '获取图表时间区间失败'})
    commit('setPiDataPeriod', data)
  },
  setPiCanPeratePeriod ({ commit, dispatch }, data) {
    data.pass = data.perateEndTime && data.perateStartTime
    dispatch('setPiErrorInfo', {key: 'peratePeriod', errorText: data.pass ? null : '获取到达时间区间失败'})
    commit('setPiCanPeratePeriod', data)
  },
  setPiHourStatus ({ commit, dispatch }, data) {
    commit('setPiHourStatus', data)
    dispatch('updatePiStockChartOption')
  },
  setPiErrorInfo ({ commit }, data) {
    commit('setPiErrorInfo', data)
  },
  clearPiErrorInfo ({ commit }) {
    commit('clearPiErrorInfo')
  }
}

const mutations = {
  updatePiInOrderByType (state, {type, data}) {
    let newPiInOrder = []
    state.piInOrder.forEach((item) => {
      if (!item.type.includes(type)) {
        newPiInOrder.push(item)
      }
    })
    data.forEach((item) => {
      let newType = type
      if (type === 'distributionOrder') {
        newType = item.status === 'way' ? 'distributionOrderWay' : (item.status === 'end' ? 'distributionOrderEnd' : 'distributionOrderPlan')
      }
      newPiInOrder.push({
        licenseNo: item.licenseNo || null,
        arriveTime: new Date(item.arriveTime),
        volume: item.volume,
        type: newType,
        typeText: typeTextMap[newType]
      })
    })
    state.piInOrder = newPiInOrder
  },
  setPiChartShowXL (state, data) {
    state.piChartShowXL = data
  },
  setPiErrorInfo (state, data) {
    state.piErrorInfo[data.key] = data.errorText
  },
  clearPiErrorInfo (state, data) {
    state.piErrorInfo = {}
  },
  setPiStockChartOption (state, data) {
    state.piStockChartOption = data
  },
  setPiGasTankData (state, data) {
    state.piGasTank = data
  },
  setPiDataPeriod (state, data) {
    state.piDataPeriod = data
  },
  setPiCanPeratePeriod (state, data) {
    state.piCanPeratePeriod = data
  },
  setPiHourStatus (state, data) {
    state.piHourStatus = data
  },
  setPiGasTankId (state, data) {
    state.piGasTankId = data
  },
  setPiChartType (state, data) {
    state.piChartType = data
  },
  setPiRouterOrder (state, data) {
    state.piGasRouterOrder = data
  },
  setPiGasPiOrder (state, data) {
    state.piGasPiOrder = data
  },
  setPiDistributionOrder (state, data) {
    state.piGasDistributionOrder = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pi/pi_stock_chart.js